// Centralized validation messages to avoid repetition.
// If business rules change, update here only.

export const VALIDATION_MESSAGES = {
  CITIZENSHIP_REQUIRED: "Cédula de ciudadanía requerida",
  CITIZENSHIP_DIGITS_ONLY: "Debe contener solo dígitos (0-9).",
  CITIZENSHIP_LENGTH: "Debe tener entre 6 y 10 dígitos.",

  NAME_REQUIRED: "El nombre es obligatorio",
  CITY_REQUIRED: "La ciudad es obligatoria",
  BUILDING_REQUIRED: "La unidad residencial es obligatoria",
  PASSWORD_REQUIRED: "Contraseña requerida",
  STATUS_REQUIRED: "El estado es obligatorio",


  TOWER_REQUIRED: "La torre es obligatoria",
  APARTMENT_REQUIRED: "El apartamento es obligatorio",
  AGE_CLASSIFICATION_REQUIRED: "La clasificación de edad es obligatoria",
  SWIMMER_TYPE_REQUIRED: "El tipo de bañista es obligatorio",
  SWIMMERS_MIN_REQUIRED: "Debe agregar al menos un bañista",
  SWIMMERS_MAX_REQUIRED: "No se pueden registrar más de 10 bañistas a la vez",
  SWIMMERS_REFERENCE_INVALID: "La referencia al responsable no es válida",
  SWIMMERS_ADULTS_REQUIRED: "Debe crear al menos un adulto (Mayor de 18 años) cuando hay menores de 12 años en el grupo",
  SWIMMERS_MINOR_AGE_REQUIRED: "Los menores de 12 años deben tener un responsable asignado",

  MONTH_RANGE: "El mes debe ser entre 1 y 12",
  YEAR_RANGE: "El año debe ser entre 2000 y 2100",

  // News/Reports validation messages
  EVENT_TIMESTAMP_REQUIRED: "La fecha y hora del evento es obligatoria",
  EVENT_TIMESTAMP_TIME_RANGE:
    "La hora del evento debe estar entre 8:00 a.m. y 6:00 p.m.",
  REPORT_TYPE_REQUIRED: "El tipo de reporte es obligatorio",
  EVENT_DESCRIPTION_REQUIRED: "La descripción del evento es obligatoria",
  SECURITY_OFFICER_NAME_REQUIRED: "El nombre del oficial de seguridad es obligatorio",
  SECURITY_OFFICER_NAME_MAX_LENGTH: "El nombre del oficial de seguridad no puede exceder 150 caracteres",
  MAINTENANCE_TYPE_REQUIRED: "El tipo de mantenimiento es obligatorio",
  POOL_REGULATION_TYPE_REQUIRED: "El tipo de incumplimiento es obligatorio",
  INTERVENTION_LEVEL_REQUIRED: "El nivel de intervención es obligatorio",
  ADVERSE_EVENT_TYPE_REQUIRED: "El tipo de evento adverso es obligatorio",
  SPENT_ITEMS_REQUIRED_FOR_ACCIDENT: "Los elementos gastados son obligatorios para 'Accidente'",
  EVENT_SPECIFIC_FACTOR_REQUIRED: "El factor específico del evento es obligatorio para Accidente e Incidentes",
  ADVERSE_EVENT_INTERVENTION_LEVEL_REQUIRED: "El nivel de intervención es obligatorio para Accidente e Incidentes",

  // Management report / date range
  START_DATE_REQUIRED: "La fecha de inicio es requerida",
  END_DATE_REQUIRED: "La fecha de fin es requerida",
  DATE_FORMAT_DDMMYYYY: "Formato inválido. Use DD/MM/YYYY",
  DATE_FORMAT_INVALID: "Formato de fecha inválido",
  REPORT_BUILDING_REQUIRED: "Selecciona una unidad residencial",
  START_DATE_BEFORE_END: "La fecha de inicio debe ser anterior o igual a la fecha de fin",
  DATE_RANGE_MAX_32_DAYS: "El rango de fechas no puede exceder 32 días",
};

export type ValidationMessageKey = keyof typeof VALIDATION_MESSAGES;

export const vm = VALIDATION_MESSAGES; // vm as validation message alias
